import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editSetting, getSettingApi } from "../../store/setting/setting.action";
import Button from "../../extra/Button";
import Input from "../../extra/Input";


const RefralBonus = () => {
  const { settingData } = useSelector((state) => state.setting);

  const dispatch = useDispatch();

  const [referrerRewardCoins, setReferrerRewardCoins] = useState(0);
  const [referredRewardCoins, setReferredRewardCoins] = useState(0);

  const [error, setError] = useState({
    referrerRewardCoins: "",
    referredRewardCoins: "",
  });

  useEffect(() => {
    setReferrerRewardCoins(
      settingData?.referrerRewardCoins ?? settingData?.referralRewardCoins ?? 0
    );
    setReferredRewardCoins(
      settingData?.referredRewardCoins ?? settingData?.referralRewardCoins ?? 0
    );
  }, [settingData]);

  useEffect(() => {
    dispatch(getSettingApi());
  }, []);

  const handleSubmit = () => {
    const referrerValue = Number(referrerRewardCoins);
    const referredValue = Number(referredRewardCoins);

    const nextError = {};

    if (referrerRewardCoins === "" || Number.isNaN(referrerValue) || referrerValue < 0) {
      nextError.referrerRewardCoins = "Referrer reward is invalid !";
    }

    if (referredRewardCoins === "" || Number.isNaN(referredValue) || referredValue < 0) {
      nextError.referredRewardCoins = "Referred reward is invalid !";
    }

    if (Object.keys(nextError).length > 0) {
      return setError(nextError);
    }

    const settingDataSubmit = {
      referralRewardCoins: Number(referrerRewardCoins) || 0,
      referrerRewardCoins: Number(referrerRewardCoins) || 0,
      referredRewardCoins: Number(referredRewardCoins) || 0,
    };

    dispatch(editSetting(settingData?._id, settingDataSubmit));
  };

  return (
    <div className="userPage withdrawal-page p-0">
      <div className="row">
        <div className="col-12">
          <div className="withdrawal-box payment-setting ">
            <div className="row align-items-center p-2">
              <div className="col-12 col-sm-6 ">
                <h5>Referral Reward</h5>
              </div>
              <div className="col-12 col-sm-6 sm-m-0 d-flex justify-content-end p-0">
                <Button
                  btnName={"Submit"}
                  type={"button"}
                  onClick={handleSubmit}
                  newClass={"submit-btn"}
                  style={{
                    borderRadius: "0.5rem",
                    width: "88px",
                    marginLeft: "10px",
                  }}
                />
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-12 col-md-6 withdrawal-input mb-3">
                <Input
                  label={"Referrer Reward Coins"}
                  name={"referrerRewardCoins"}
                  value={referrerRewardCoins}
                  type={"number"}
                  min={0}
                  errorMessage={error.referrerRewardCoins}
                  placeholder={"0"}
                  onChange={(e) => {
                    setReferrerRewardCoins(e.target.value);
                  }}
                />
              </div>

              <div className="col-12 col-md-6 withdrawal-input mb-3">
                <Input
                  label={"Referred Reward Coins"}
                  name={"referredRewardCoins"}
                  value={referredRewardCoins}
                  type={"number"}
                  min={0}
                  errorMessage={error.referredRewardCoins}
                  placeholder={"0"}
                  onChange={(e) => {
                    setReferredRewardCoins(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefralBonus;
